import { GET_SWITCHES_VALUES, CHANGE_SETTING_LOCAL, CHANGE_SETTING, CLEAN_SWITCHES_STATES, SET_SHOW_SECTION, SET_FILTER_NAME } from "./types";

const SettingsReducer = (state, action) => {
    const { type, payload } = action;
    switch (type) {
        case GET_SWITCHES_VALUES:
            return {
                ...state,
                switches: payload.switches,
                isFetching: false,
                error: payload.error
            }
        case SET_SHOW_SECTION:
            return {
                ...state,
                showSection: payload,
            }
        case SET_FILTER_NAME:
            return {
                ...state,
                filterName: payload,
            }
        case CLEAN_SWITCHES_STATES:
            return {
                ...state,
                switches: [],
                isFetching: true,
                error: {
                    ok: false,
                    text: ''
                }
            }
        case CHANGE_SETTING:
            return {
                ...state,
                switches: payload.switches,
                isFetching: false,
                error: payload.error
            }
        case CHANGE_SETTING_LOCAL:
            return {
                ...state,
                switches: payload,
            }
        default:
            return state;
    }
}

export default SettingsReducer